import type { ArtworkForm, PlacementFormPosition, Side } from "@design-lab/shared/types";

const placementToSideMap: Record<PlacementFormPosition, Side> = {
  front: "front",
  back: "back",
  frontLeftChest: "front"
};

/**
 * Gets the side (front or back) for a given placement.
 *
 * @param placement - The placement position
 * @returns The side that the placement belongs to
 */
export function getSideFromPlacement(placement: PlacementFormPosition): Side {
  return placementToSideMap[placement];
}

/**
 * Gets artwork ID for a given side.
 *
 * For front side, it returns whichever artwork ID is available between front or frontLeftChest placements.
 * For back side, it returns the artwork ID of the back placement.
 *
 * @param artworkForm - The artwork form data
 * @param side - The side (front or back)
 * @returns The artwork ID or empty string if not found
 */
export function getArtworkIdBySide(artworkForm: ArtworkForm | undefined, side: Side): string {
  if (!artworkForm) return "";

  if (side === "back") {
    return artworkForm.back?.artworkId || "";
  }

  return artworkForm.front?.artworkId || artworkForm.frontLeftChest?.artworkId || "";
}
